import { createAction } from '@ngrx/store';
import { ActionCreator } from '@ngrx/store/src/models';
import { TimeZone } from 'app/modules/main/models/time-zone';

export type LoadAdvertiserTimeZoneAction = ActionCreator;

export class AdvertiserTimeZoneActions {

  /**
   * ${...} contains implementation details internal to this feature,
   * do not dispatch these from outside of this feature but instead
   * create a meaningful domain event describing what has happened to cause
   * the side effect and/or state change, and where the change originated from
   *
   * Domain events are configured using the following injection tokens:
   *
   *   @see AdvertiserTimeZoneActions.LOAD_TIME_ZONE
   **/
  static $ = class {

    static readonly loadingAdvertiserTimeZone =
      createAction(
        '[Advertiser Timezone Feature] Loading Advertiser Timezone',
      );

    static readonly advertiserTimeZoneLoaded =
      createAction(
        '[Advertiser Timezone Feature] Advertiser Timezone Loaded',
        (timeZone: TimeZone) => ({ timeZone }),
      );

    static readonly advertiserTimeZoneLoadFailed =
      createAction(
        '[Advertiser Timezone Feature] Advertiser Timezone Load Failed',
        (error?: string) => ({ error }),
      );
  };

}
